<script>
 const BASE_URL = 'http://osce-new.sublab.cn/';
 // const BASE_URL = 'http://osce-new.test/';
 // const BASE_URL=window.location.protocol+"//"+window.location.host+'/';
    export default{
        BASE_URL
    }
</script>



// WEBPACK FOOTER //
// src/components/Common/Global.vue